export default __webpack_public_path__ + "static/questions-4ac96bb99ce37c76da7457d94b04f3d4.png";